import { createGlobalStyle } from 'styled-components';
import DotImage from '../images/dot.svg';
import DivBreadcrumb from '../images/div-breadcrumb.svg';
import SelectIcon from '../images/select-icon.svg';
import IconCheck from '../images/icon-check.svg';
import IconDelete from '../images/icon-delete.svg';
import IconMenu from '../images/icon-menu.svg';
import IconListPricing from '../images/icon-list-pricing.svg';
import IconListPricingWhite from '../images/icon-list-pricing-white.svg';
import IconDown from '../images/icon-down.svg';

import IconGoogle from '../images/icon-google.svg';
import IconGithub from '../images/icon-github.svg';
import IconFacebook from '../images/icon-facebook-2.svg';

import FlagUsaInactive from '../images/flag-usa-inactive.svg';
import FlagUsaActive from '../images/flag-usa-active.svg';
import FlagBrazilInactive from '../images/flag-brazil-inactive.svg';
import FlagBrazilActive from '../images/flag-brazil-active.svg';
import FlagSpainInactive from '../images/flag-spain-inactive.svg';
import FlagSpainActive from '../images/flag-spain-active.svg';
import FlagItalyInactive from '../images/flag-italy-inactive.svg';
import FlagItalyActive from '../images/flag-italy-active.svg';
import FlagTurkeyInactive from '../images/flag-turkey-inactive.svg';
import FlagTurkeyActive from '../images/flag-turkey-active.svg';
import FlagSaudiInactive from '../images/flag-saudi-inactive.svg';
import FlagSaudiActive from '../images/flag-saudi-active.svg';
import FlagChinaInactive from '../images/flag-china-inactive.svg';
import FlagChinaActive from '../images/flag-china-active.svg';

export default createGlobalStyle`
	* {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}
	ul,
	li {
		list-style-type: none;
	}
	a, button, input[type=submit]{
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
	}
	a,
	img,
	a:hover, button {
		text-decoration: none;
		outline: none !important;
	}
	img{
		max-width: 100%;
		height: auto;
	}
	:focus, :hover, :active{
		outline: none !important;
	}

	/* BODY */

	main.flagship{
		padding-top: 0;
	}
	.margin-bottom-100{
		margin-bottom: 100px !important;
	}

	/* HEADER */

	header nav.navbar{
    background: #FFFFFF;
    box-shadow: 0px 4px 250px -25px rgba(0, 0, 0, 0.25);
    -webkit-transition: all .3s;
    -moz-transition: all .3s;
    transition: all .3s;
	}
	.logo{
		display: flex;
		height: 60px;
	}

	header nav.navbar .nav-item{
		margin: 0 10px;
	}
	header nav.navbar .nav-item a{
		color: #44393E;
		font-size: 14px;
		font-family: 'Montserrat Light';
		font-weight: 400;
	}
	header nav.navbar .nav-item a:hover{
		color: #FF6A72;
	}
	header nav.navbar .nav-item.featured a{
		color: #ffffff;
		font-family: 'Montserrat Semibold';
		background: linear-gradient(100.6deg, #FF3F95 -18.79%, #FF431C 125.68%);
		box-shadow: 0px 8px 10px -7px rgba(255, 106, 114, 0.6);
		border-radius: 8px;
		padding: 7px 20px 9px;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
	}
	header nav.navbar .nav-item.featured a:hover{
		box-shadow: 0px 0px 20px -4px rgb(255 106 114 / 60%);
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
	}
	header nav.navbar .nav-item .nav-link.active{
		color: #FF6A72;
		font-family: 'Montserrat Semibold';
	}

	/* LOGO */

	.logo{
		display: flex;
		height: 60px;
	}

	/* TITLE */

	.title{
		font-family: 'Montserrat Extrabold';
		font-size: 36px;
		line-height: 40px;
	}
	h1.title.pink{
		color: #FF6A72;
	}
	h1.title{
		color: #44393E;
		font-family: 'Montserrat Extrabold';
		font-size: 46px;
		line-height: 46px;
	}
	h2.subtitle{
		color: #44393E;
		font-family: 'Montserrat Regular';
		font-size: 46px;
		line-height: 46px;
	}
	.title-pages h1{
		color: #FF6A72;
		font-family: 'Montserrat Semibold';
		font-size: 36px;
		line-height: 40px;
	}
	.title-pages .text{
		margin: 60px 0;
	}

	/* ERROR */

	.error-page{
		margin: 50px 0 100px!important;
	}
	.error-page h1.title{
		margin-bottom: 0;
	}
	.error-page h2.subtitle{
		margin-bottom: 30px;
		font-family: 'Montserrat Extralight';
	}

	/* FEATURES BUTTONS */

	.logged .title-pages .text {
		margin: 20px 0;
	}
	.features-buttons {
		margin-bottom: 80px;
	}
	.features-buttons .button-feature a{
		width: 100%;
		float: left;
		color: #ffffff;
		font-family: 'Montserrat Semibold';
		background: linear-gradient(100.6deg, #FF431C -70%, #FF3F95 125.68%);
		box-shadow: 0px 8px 10px -7px rgba(255, 106, 114, 0.6);
		border-radius: 35px;
		padding: 30px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1);
	}
	.features-buttons .button-feature a:hover{
		transform: scale(1.05);
	}
	.features-buttons .button-feature a .qty-info{
		float: left;
	}
	.features-buttons .button-feature a .qty-info h2{
		font-family: 'Montserrat Semibold';
		font-size: 32px;
		margin-bottom: 0;
	}
	.features-buttons .button-feature a .qty-info legend{
		font-family: 'Montserrat Regular';
		font-size: 14px;
	}
	.features-buttons .button-feature a .img-feature{
		float: right;
	}

	/* CARDS */

	.cards .card{
		padding: 30px;
		border-radius: 25px;
		border: 1px solid #DEDEDE;
		margin-bottom: 30px;
	}
	.cards .card h2{
		font-size: 24px;
		font-family: 'Montserrat Extrabold';
		color: #FF6A72;
	}
	.cards .card header{
		margin-bottom: 30px;
	}
	.cards .card header > div{
		float: left;
	}
	.cards .card header > div.name{
		margin-left: 20px;
	}
	.cards .card header > div.time{
		float: right !important;
	}
	.cards .card .content{
		width: 100%;
		float: left;
		padding-left: 89px;
	}
	.cards .card .content h2{
		color: #44393E;
		font-size: 16px;
		font-family: 'Montserrat Semibold';
		margin-bottom: 20px;
	}
	.cards .card .content p{
		color: #44393E;
		font-size: 14px;
		font-family: 'Montserrat Regular';
	}
	.cards .divisor {
		margin: 0 0 50px;
	}
	.cards .divisor > div{
		padding-right: 0;
	}
	.cards .divisor a{
		margin-left: 15px;
	}

	/* LINES */

	.lines .line{
		border: 1px solid #E7E7E7;
		background: #ffffff;
		border-radius: 25px;
		padding: 25px;
		margin-top: 10px;
	}
	.lines .line.not-read{
		background: #F6F6F6;
	}
	.lines .line .link-line{
		display: block;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1);
	}
	.lines .line .link-line:hover{
		transform: scale(.98);
	}
	.lines .line .row{
		margin: auto;
	}
	.cards .card .img,
	.lines .line .img{
		text-align: center;
		width: 60px;
		height: 60px;
		background: #FFFFFF;
		border: 1px solid #E0E0E0;
		border-radius: 10px;
		padding: 10px;
	}
	.lines .line .name p{
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		float: left;
		margin-bottom: 0;
	}
	.cards .card .name span{
		font-size: 20px;
		font-family: 'Montserrat Extrabold';
		color: #FF6A72;
		margin-left: 10px;
		float: left;
	}
	.lines .line .name span{
		width: 100%;
		color: #FF6A72;
		font-size: 14px;
		font-family: 'Montserrat Semibold';
		float: left;
		margin-bottom: 5px;
	}
	.lines .line .img img{
		width: 34px;
	}
	.lines .line .actions .content-check{
		width: 24px;
		height: 24px;
		margin-bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.lines .line.not-read .actions .content-check .check{
		padding-top: 5px;
	}
	.lines .line .actions .content-check .check{
		width: 18px;
		height: 18px;
	}
	.cards .card .time span,
	.lines .line .time span{
		color: #818181;
		font-size: 14px;
		font-weight: 300;
		margin-bottom: 5px;
	}
	.lines .line .actions a{
		display: inline-block;
		margin-left: 10px;
	}
	.lines .line .actions a img{
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1);
	}
	.lines .line .actions a:hover img{
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1.1);
	}

	/* PAGINATION */

	.container-pagination {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		margin-top: 30px;
	}
	.container-pagination div p{
		font-size: 12px;
	}
	.container-pagination .pagination .page-item a{
		background:#EEEEEE;
		color: #44393E;
		box-shadow: none;
		border: none;
		outline: none;
		border-radius: 10px;
		margin: 0 3px;
	}
	.container-pagination .pagination .page-item.active a{
		background:#FF6A72;
		color: #ffffff;
	}
	.container-pagination .pagination .page-item a:focus,
	.container-pagination .pagination .page-item a:hover{
		box-shadow: none;
		border: none;
		outline: none;
	}
	.container-pagination .pagination .page-item a:hover{
		background:#FF6A72;
		color: #ffffff;
	}

	/* FLAGSHIP */

	.content-flagship .title{
		margin-bottom: 15px;
	}
	.content-flagship .container{
		max-width: 1100px;
		margin: auto;
	}
	.content-flagship .logo{
		margin: 50px auto;
		align-items: center;
		justify-content: center;
	}
	.content-flagship .logo img{
		width: 280px;
	}
	.content-flagship .img-coming-soon{
		padding: 30px;
	}

	/* CARD LIST */

	.list-recent-activity .list-group{
		border: 0;
		padding:0;
	}
	.list-recent-activity .list-group .list-group-item{
		padding:0 0 0 30px;
		border: 0;
		position: relative;
	}
	.list-recent-activity .list-group .list-group-item::before{
		content:'';
		background: url(${DotImage}) no-repeat center;
		width: 16px;
		height: 16px;
		position: absolute;
		left: 0;
		top: 4px;
	}
	.list-recent-activity .list-group .list-group-item .date{
		color: #464255;
		font-family: 'Montserrat Semibold';
		font-size: 15px;
		margin-bottom: 8px;
	}
	.list-recent-activity .list-group .list-group-item p{
		font-size: 14px;
		line-height: 22px;
		color: #A3A3A3;
	}

	/* BUTTON */

	/* .button{
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 8px !important;
		font-family: 'Montserrat Semibold';
		font-style: normal;
		font-size: 18px;
		width: auto;
		height: 52px;
		padding: 0 35px;
		clear: both;
		border: 0;
	} */
	.button.dark{
		background: linear-gradient(100.6deg, #FF3F95 -18.79%, #FF431C 125.68%) !important;
		box-shadow: 0px 8px 10px -7px rgba(255, 106, 114, 0.6) !important;
		color: #fff !important;
		-webkit-transition: all .3s !important;
		-moz-transition: all .3s !important;
		transition: all .3s !important;
	}
	.button.dark:hover{
		background: linear-gradient(100.6deg, #44393E -18.79%, #2e2428 125.68%) !important;
		-webkit-transition: all .3s !important;
		-moz-transition: all .3s !important;
		transition: all .3s !important;
	}
	.button.yellow{
		background: #FEC349;
		box-shadow: 0px 8px 10px -7px #FFE18F;
		color: #fff;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		display: flex;
	}
	.button.yellow:hover{
		background: #FFB317;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
	}
	.button.yellow img{
		margin-top: -6px;
	}
	.button.black{
		background: #353738;
		box-shadow: 0px 8px 10px -7px #C0C0C0;
		color: #fff;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		display: flex;
	}
	.button.black img{
		height: 24px;
		margin-right: 10px;
	}
	.button.black:hover{
		background: #1E1E1F;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
	}
	.button.super-small {
		height: 26px;
		padding: 0px 10px 2px;
		width: auto;
		font-size: 12px;
	}
	.button.small {
		height: 34px;
		padding: 0px 20px 2px;
		width: auto;
		font-size: 14px;
	}
	.button.light{
		background: #ffffff;
		border: 1px solid #FF6A72;
		box-shadow: none;
		color: #FF6A72;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
	}
	.button.light:hover{
		background: #FF6A72;
		border: 1px solid #FF6A72;
		color: #ffffff;
	}

	/* HOME */

	.banner-home{
		width: 100%;
		max-width: 1100px;
		display: grid;
		margin: 0 auto 50px;
	}
	.banner-home h2{
		color: #44393E;
		margin-bottom: 20px;
	}
	.banner-home p{
		margin-bottom: 45px;
	}
	.banner-home .button{
		max-width: 265px;
		text-align: center;
		line-height: 19px;
	}

	/* HOME GENERATE QRCODE */

	.generate-qrcode {
		width: 100%;
		max-width: 1100px;
		margin: 70px auto 20px;
	}
	.generate-qrcode .container .card-generate{
		height: 458px;
	}
	.generate-qrcode .container .card-generate .content{
		padding: 40px;
		border: 1px solid #DEDEDE;
		border-radius: 25px;
	}
	.generate-qrcode .container .card-generate .content .title{
		margin-bottom: 25px;
	}
	.generate-qrcode .container .card-generate .content .title h2{
		font-size: 18px;
		color: #FF6A72;
		font-family: 'Montserrat Semibold';
	}
	.generate-qrcode .container .card-generate .content .form form > div{
		margin-bottom: 20px;
	}
	.generate-qrcode .container .card-generate .content .form form > div:last-of-type{
		margin-bottom: 0;
	}
	.generate-qrcode .container .card-generate .content .form form > div input{
		border: 1px solid #ECEAF3;
		border-radius: 15px;
		padding: 15px 20px 15px 18px;
	}
	.generate-qrcode .container .card-generate .content .form form > div input:disabled {
		background: transparent;
	}
	.generate-qrcode .container .card-generate .content .form form > div.disabled{
		position: relative;
	}
	.generate-qrcode .container .card-generate .content .form form > div.disabled input::placeholder{
		color: #C4C4C4 !important;
	}
	.generate-qrcode .container .card-generate .content .form form > div.disabled .pro{
		background: #FFD255;
		box-shadow: 0px 8px 10px -7px #FFD255;
		color: #ffffff;
		font-family: 'Montserrat Semibold';
		padding: 4px 8px;
		border-radius: 10px;
		position: absolute;
		right: 30px;
		top: 12px;
		margin-bottom: 0;
	}
	.generate-qrcode .container .card-generate .content .content-qrcode .qrcode{
		border: 1px solid #ECECEC;
		border-radius: 25px;
		padding: 25px;
		text-align: center;
		margin-bottom: 15px;
	}
	.generate-qrcode .container .card-generate .content .content-qrcode .qrcode img {
		height: 175px;
		opacity: .3;
	}
	.generate-qrcode .container .card-generate .content .content-qrcode p{
		font-size: 12px;
	}
	.generate-qrcode .container .card-generate .content .content-qrcode .buttons a{
		width: 49%;
	}

	/* SECTION IMAGE + TEXT */

	.section-image-text{
		width: 100%;
		float: left;
		margin-bottom: 20px;
		clear: both;
	}
	.section-image-text .button{
		margin-top: 20px;
	}
	.section-image-text .text{
		max-width: 400px;
	}
	.section-image-text p, .section-image-text span{
		color: #727272;
	}
	.section-image-text h2.title{
		color: #FF6A72;
	}
	.section-image-text .title{
		margin-bottom: 20px;
	}

	/* INTERNAL */

	.title-pages{
		text-align: center;
		max-width: 460px;
		margin: 20px auto 60px;
	}
	.content-page .form{
		max-width: 635px;
		margin: auto;
	}
	.logged .content-page .form.full{
		max-width: 100%;
	}
	.logged .content-page .form .divisor{
		max-width: 100%;
		position: relative;
		margin: 0;
		padding: 0;
	}
	.logged .content-page .form .divisor::before{
		content: '';
		background: #ECECEC;
		width: 98.5%;
		height: 5px;
		margin: 20px auto 40px;
		display: block;
	}
	.logged .content-page .form .divisor .button{
		width: auto;
	}
	.logged .content-page .form form > div{
		margin-bottom: 30px;
	}
	.logged.left .title-pages{
		max-width: 100%;
		text-align: left;
		margin: 20px 0 40px;
	}

	/* BREADCRUMB */

	.breadcrumb {
		margin-bottom: 45px;
	}
	.breadcrumb li {
		position: relative;
	}
	.breadcrumb li a{
		color: #44393E;
		font-size: 12px;
		max-width: 200px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
	.breadcrumb li a:hover{
		color: #FF6A72;
	}
	.breadcrumb li.active{
		color: #FF6A72;
		font-family: 'Montserrat Semibold';
		font-size: 12px;
		line-height: 27px;
		max-width: 200px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
	.breadcrumb-item+.breadcrumb-item {
		padding-left: 38px;
	}
	.breadcrumb-item+.breadcrumb-item::before{
		content:'';
		background: url(${DivBreadcrumb}) no-repeat center;
		width: 6px;
		height: 6px;
		position: absolute;
		top: 10px;
		left: 15px;
	}

	/* CONTENT PAGE */

	.content-page{
		margin-bottom: 50px;
	}
	.content-page h2{
		color: #FF6A72;
		font-family: 'Montserrat Semibold';
		font-style: normal;
		font-size: 36px;
	}
	.content-page .title{
		text-align: center;
		margin: 10px auto 80px;
		max-width: 700px;
	}
	.content-page .text{
		margin: 0 auto 50px;
		max-width: 1100px;
	}
	.content-page .text .featured .icon{
		width: 34px;
		height: 34px;
		margin-bottom: 15px;
	}
	.content-page .text .featured .icon img{
		width: 100%;
		max-width: 34px;
	}
	.content-page .text .featured h3{
		font-family: 'Montserrat Semibold';
		font-size: 18px;
		color: #44393E;
	}
	.content-page .text .featured p{
		color: #727272;
		font-size: 14px;
	}
	.content-page .divisor{
		max-width: 605px;
		width: 100%;
		margin: 60px auto;
	}
	.content-page .divisor hr{
		margin-bottom: 0;
		padding-bottom: 0;
		color: #afafaf;
	}
	.content-page .divisor span{
		font-family: 'Montserrat Regular';
		font-size: 18px;
		text-align: center;
		color: #818181;
	}
	.content-page .social{
		max-width: 635px;
		width: 100%;
		margin: 60px auto;
	}
	.content-page .social .copy{
		max-width: 315px;
		text-align: center;
		margin: auto;
	}
	.content-page .social .copy a{
		font-family: 'Montserrat Semibold';
		color:#FF6A72;
	}
	.content-page .social .copy a:hover{
		color:#D9575E;
	}
	.content-page .social div{
		text-align: center;
	}
	.content-page .social div ul{
		padding: 0;
		margin: 0px auto 50px;
	}
	.content-page .social div ul li{
		margin: 0 5px;
	}
	.content-page .social div ul li a img{
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1);
	}
	.content-page .social div ul li a:hover img{
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1.1);
	}

	/* TABLE */

	.table{
		border: 1px solid #DEDEDE;
		border-radius: 25px 25px 0 0;
	}
	.table .title-table{
		width: 100%;
		padding: 15px 0;
	}
	.table .title-table span{
		color: #44393E;
		font-size: 13px;
		font-family: 'Montserrat Regular';
	}
	.table .table-line{
		border-top: 1px solid #DEDEDE;
		border-bottom: 1px solid #DEDEDE;
		margin-top: -1px;
		padding: 5px;
	}
	.table .title-table .row,
	.table .table-line .row{
		margin: auto;
	}
	.table .table-line:last-of-type{
		margin-bottom: -1px;
	}
	.table .table-line:nth-child(even){
		background: #F9F9F9;
	}
	.table .table-line:nth-child(odd){
		background: #FFFFFF;
	}
	.table .table-line div span{
		display: none;
	}
	.table .table-line .img{
		text-align: center;
	}
	.table .table-line .img img{
		max-width: 32px;
		padding: 5px;
		text-align: center;
		background: #FFFFFF;
		border: 1px solid #E0E0E0;
		border-radius: 5px;
	}
	.table .table-line p{
		margin-bottom: 0;
		font-size: 13px;
	}
	.table .table-line .actions a:first-of-type{
		margin-left: 0;
	}
	.table .table-line div a,
	.table .table-line div a p{
		padding: 0;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1);
	}
	.table .table-line div > a:hover{
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1.01);
	}
	.table .table-line div > a:hover p{
		color: #FF6A72;
	}
	.table .table-line .actions{
		text-align: center;
	}
	.table .table-line .actions a {
		margin-left: 5px;
		display: inline-block;
	}
	.table .table-line .actions a img{
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1);
	}
	.table .table-line .actions a:hover img{
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1.1);
	}

	/* QR CODE */

	.qrcode div div > div {
		margin-bottom: 30px;
		padding: 0;
	}
	.qrcode div label{
		width: 100%;
		color: #44393E;
		font-size: 14px;
		margin-bottom: 5px;
	}
	.qrcode div p{
		font-size: 20px;
		color: #FF6A72;
		font-family: 'Montserrat Extrabold';
		margin-bottom: 0;
	}
	.qrcode div .button.light.super-small{
		margin-top: 10px;
	}
	.qrcode figure{
		border: 1px solid #ECECEC;
		padding: 30px;
		border-radius: 30px;
		width: auto;
		float: left;
	}
	.qrcode figure img{
		max-width: 250px;
	}
	.qrcode .divisor::before {
		content: '';
		background: #ECECEC;
		width: 100%;
		height: 5px;
		margin: 20px auto 40px;
		display: block;
	}
	.qrcode .divisor{
		max-width: 100%;
		width: 100%;
		margin: 60px auto;
	}
	.qrcode .download-qrcode{
		display: block;
		clear: both;
	}
	.qrcode .download-qrcode a{
		margin-right: 10px;
	}

	/* CHECKOUT */

	.checkout{
		margin: 60px auto;
	}
	.checkout .content{
		width: 100%;
		padding: 40px;
		border: 1px solid #DEDEDE;
		border-radius: 25px;
		float: left;
	}
	.checkout .content .price{
		padding-bottom: 30px;
		margin-bottom: 30px;
		border-bottom: 1px solid #E8E8E8;
	}
	.checkout .content .price .title,
	.checkout .content .payment .title{
		font-size: 18px;
		line-height: 22px;
		color: #FF6A72;
		font-family: 'Montserrat Semibold';
		margin-bottom: 15px;
	}
	.checkout .content .price p{
		color:#44393E;
		margin-bottom: 0;
	}
	.checkout .content .payment .text strong,
	.checkout .content .price .value{
		font-family: 'Montserrat Extrabold';
	}
	.checkout .content .payment{
		margin-bottom: 40px;
	}
	.checkout .content .payment .text p{
		color:#44393E;
	}
	.checkout .content .payment .text p a{
		color: #FF6A72;
	}
	.checkout .content .payment .text p a:hover{
		color: #D9575E;
	}
	.checkout .content .buttons{
		text-align: center;
		float: left;
		width: 100%;
	}
	.checkout .content .buttons small{
		width: 100%;
		float: left;
		margin-top: 30px;
	}
	.checkout .checkout-buttons{
		width: 100%;
		margin-bottom: 25px;
		display: flex;
	}
	.checkout .checkout-buttons .buttons{
		width: 100%;
	}
	.checkout .checkout-buttons .buttons .btn-aba{
		width: 48%;
	}
	.checkout .checkout-buttons .buttons .btn-aba a{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-direction: row;
		border: 1px solid #FF6A72;
		padding: 15px 25px;
		border-radius: 25px;
		overflow: hidden;
	}
	.checkout .checkout-buttons .buttons .btn-aba a span{
		font-size: 18px;
		line-height: 22px;
		color: #FF6A72;
		font-family: 'Montserrat Semibold';
		border: 1px solid #FF6A72;
		border-radius: 50%;
		width: 36px;
		height: 36px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 20px;
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
	}
	.checkout .checkout-buttons .buttons .btn-aba a p{
		margin-bottom: 0;
		font-size: 16px;
		line-height: 22px;
		color: #FF6A72;
		font-family: 'Montserrat Semibold';
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
	}
	.checkout .checkout-buttons .buttons .btn-aba.actived.actual a:hover,
	.checkout .checkout-buttons .buttons .btn-aba.actived a{
		background: #FF6A72;
		border: 1px solid #FF6A72;
	}
	.checkout .checkout-buttons .buttons .btn-aba a:hover,
	.checkout .checkout-buttons .buttons .btn-aba.actived a:hover{
		background: #ff3a7c;
		border: 1px solid #ff3a7c;
	}
	.checkout .checkout-buttons .buttons .btn-aba a:hover p,
	.checkout .checkout-buttons .buttons .btn-aba.actived a p{
		color: #fff;
	}
	.checkout .checkout-buttons .buttons .btn-aba a:hover span,
	.checkout .checkout-buttons .buttons .btn-aba.actived a span{
		background: #FFFFFF;
		border: 1px solid #FFFFFF;
	}
	.checkout .checkout-buttons .buttons .btn-aba.actual a{
		cursor: default;
	}
	.checkout .content .nav-tabs{
		border-bottom: 0;
		margin-bottom: 25px;
	}
	.checkout .content .nav-tabs .nav-item{
		margin-right: 20px;
	}
	.checkout .content .nav-tabs .nav-item:last-of-type{
		margin-right: 0;
	}
	.checkout .content .nav-tabs .nav-item .nav-link.active{
		color: #FF6A72;
		font-size: 18px;
		font-family: 'Montserrat Extrabold';
		padding: 0;
		border: 0;
	}
	.checkout .content .nav-tabs .nav-item .nav-link{
		color: #A1A1A1;
		font-size: 18px;
		font-family: 'Montserrat Regular';
		padding: 0;
		border: 0;
	}
	.checkout .content .tab-content .content-button{
		text-align: center;
	}
	.checkout .content .tab-content .content-button .button{
		max-width: 370px;
	}
	.checkout .content .tab-content .divisor {
		width: 100%;
		margin: 40px auto;
	}
	.checkout .content .tab-content .divisor .row{
		width: 100%;
		margin: auto;
	}
	.checkout .content .tab-content .divisor hr{
		padding-bottom: 0;
		margin-bottom: 0;
	}
	.checkout .content .tab-content .divisor span{
		text-align: center;
		font-family: 'Montserrat Regular';
		font-size: 18px;
		text-align: center;
		color: #818181;
	}
	.checkout .content .tab-content .social{
		text-align: center;
	}
	.checkout .content .tab-content .social ul{
		padding: 0;
		margin: 0;
	}
	.checkout .content .tab-content .social ul li{
		margin: 0 5px;
	}
	.checkout .content .tab-content .social ul li a img{
		-webkit-transition: all .3s;
		-moz-transition: all .3s;
		transition: all .3s;
		transform: scale(1);
	}
	.checkout .content .tab-content .social ul li a:hover img{
		transform: scale(1.1);
	}
	.checkout .content .tab-content .social .copy{
		max-width: 315px;
		text-align: center;
		margin: 30px auto 0;
	}
	.checkout .content .tab-content .social .copy p a{
		font-family: 'Montserrat Semibold';
		color: #FF6A72;
	}
	.checkout .content .tab-content .social .copy p a:hover{
		color: #D9575E;
	}

	/* FAQ */

	.section-faq{
		width: 100%;
		padding: 80px;
		background: #F9F9F9;
	}
	.section-faq .container{
		max-width: 940px;
	}
	.section-faq .title{
		width: 100%;
		text-align: center;
		padding-bottom: 80px;
	}
	.section-faq .title h2{
		color: #FF6A72;
	}
	.section-faq .accordion .accordion-item,
	.section-faq .accordion .accordion-button{
		background: transparent;
		padding: 0;
		border: 0;
	}
	.section-faq .accordion .accordion-button{
		font-family: 'Montserrat Semibold';
		color: #44393E;
		outline: none !important;
		box-shadow: none !important;
		line-height: 22px;
	}
	.section-faq .accordion .accordion-button::after{
		background: url(${IconDown}) no-repeat center;
		width: 34px;
		height: 24px;
		transform: rotate(0deg);
	}
	.section-faq .accordion .accordion-button:not(.collapsed)::after{
		transform: rotate(-180deg);
	}
	.section-faq .accordion .accordion-item{
		margin-bottom: 30px;
	}
	.section-faq .accordion .accordion-item:last-of-type{
		margin-bottom: 0;
	}
	.section-faq .accordion .accordion-item .accordion-collapse{
		border: 0;
	}
	.section-faq .accordion .accordion-item .accordion-collapse .accordion-body{
		padding: 20px 0 5px;
	}

	/* CALL TO ACTION - SIGN UP */

	.call-to-action.sign-up{
		width: 100%;
		height: 390px;
		background: #FF6A72;
		color: #fff;
	}
	.call-to-action .title{
		text-align: center;
	}
	.call-to-action.log-in a{
		min-width: 250px;
		color: #44393E;
		box-shadow: 0px 8px 10px -7px rgba(68, 57, 62, 0.6);
	}
	.call-to-action.log-in a:hover{
		background: #292427;
		color: #ffffff;
	}
	.call-to-action a{
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		min-width: 250px;
		width: auto;
		height: 52px;
		background: #FFFFFF;
		box-shadow: 0px 8px 10px -7px rgba(255, 106, 114, 0.6);
		border-radius: 8px;
		color: #FF6A72;
		cursor: pointer;
		font-style: normal;
		font-weight: bold;
		font-size: 18px;
		line-height: 30px;
		padding: 0 35px;
		padding: 0 35px;
		margin: 20px 0;
	}
	.call-to-action a:hover{
		color: #fff;
		background: #D9575E;
	}

	/* CALL TO ACTION - LOG IN */

	.call-to-action.log-in{
		width: 100%;
		min-height: 270px;
		background: #44393E;
		color: #fff;
	}

	/* FORM */
	.form{
    width: 100%;
    display: inline-block;
}
.form form .row > div{
    margin-bottom: 15px;
}

/* FORM */

.form form .border{
    padding: 20px 10px !important;
    border-width: 1px;
    border-style: solid;
    border-radius: 10px;
    margin: 0;
}
.form form .buttons .button{
    margin-right: 10px;
    padding: 4px 12px;
    border-radius: 6px;
}
.form form .buttons .button:last-child{
    margin-right: 0;
}

.form form .content-button,
.form form .subtitle-form{
    margin: 15px 0;
}
.form form .pro{
    position: relative;
}
.form form .pro .tag {
    box-shadow: 0px 8px 10px -7px #ffd255;
    border-radius: 6px;
    font-family: 'Montserrat SemiBold';
    padding: 3px 6px;
    position: absolute;
    right: 11px;
    bottom: 12px;
}
.form form .input-group .input-group-text{
    height: 40px;
    color: #C4C4C4;
    font-size: 14px;
    font-family: 'Montserrat Semibold';
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid #EDEDED;
    padding: 0 5px 0 0;
    border-radius: 0 !important;
}
.form form .input-group .button{
    padding: 3px 12px !important;
    border-radius: 6px !important;
    position: absolute;
    right: 0;
    bottom: 10px;
    z-index: 1;
}
.form form .input-group .form-control{
    padding-right: 90px;
}

form input[type=text], form input[type=number], form textarea, form input[type=password], form input[type=email], form input[type=file], form input[type=tel], form select,
form input[type=text]:disabled, form input[type=number]:disabled, form input[type=password]:disabled, form input[type=email]:disabled,
form input[type=file]:disabled, form select:disabled{
    width: 100%;
    height: 40px;
    line-height: normal;
    background-color: transparent !important;
    -webkit-appearance: none;
    appearance: none;
    padding: 0 !important;
    border: 0 !important;
    border-bottom: 1px solid #EDEDED !important;
    border-radius: 0 !important;
}
form input[type=text]:disabled, form textarea:disabled, form input[type=tel]:disabled, form input[type=number]:disabled, form input[type=password]:disabled, form input[type=email]:disabled,
form input[type=file]:disabled, form select:disabled{
    font-family: 'Montserrat ExtraLight';
}
form input[type=text]:focus, form input[type=tel]:focus, form textarea:focus,  form input[type=number]:focus, form input[type=password]:focus, form input[type=email]:focus,
form input[type=file]:focus, form select:focus{
    outline: none !important;
    box-shadow: none !important;
    border-bottom: 1px solid #6376E5 !important;
}
form input[type=text].error-input, form input[type=tel].error-input, form textarea.error-input, form input[type=number].error-input, form input[type=password].error-input, form input[type=email].error-input,
form input[type=file].error-input, form select.error-input{
    border-bottom: 1px solid #FF431C !important;
}
form input[type=file]{
    padding-top: 10px !important;
}
form select,
.select-fake{
    background-image: url(${SelectIcon});
    background-position-x: calc(100% - 10px);
    background-position-y: center;
    background-repeat: no-repeat;
    background-size: 11px;
    cursor: pointer;
}

form textarea {
    line-height: 40px !important;
    overflow: hidden;
}

.qr-code{
    width: 100%;
    padding: 30px;
    border-width: 1px;
    border-style: solid;
    display: inline-block;
}
.qr-code figure{
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
}
.qr-code figure img{
    width: 100%;
    height: auto;
    object-fit: cover;
}
.qr-code canvas {
    width: 100%;
}
.qr-code .content-url{
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
.qr-code .content-url .url{
    width: 62%;
    margin-right: 5%;
}
.qr-code .content-url .url p{
    max-width: 95%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.qr-code .content-url .content-button{
    width: 33%;
    text-align: right;
}
.qr-code .content-url .content-button .button{
    padding: 3px 12px !important;
    border-radius: 6px;
}

/* --- END QR CODE --- */

/* --- FOOTER --- */

.footer{
    clear: both;
    -webkit-transition: all .3s;
    -moz-transition: all .3s;
    transition: all .3s;
}
.footer .copy{
    line-height: normal;
}

/* NAV */

.footer nav{
    position: relative;
    margin-left: 15px;
}
.footer nav ul{
    padding: 0;
}
.footer nav ul li{
    position: relative;
    line-height: normal;
    margin: 0 15px;
}
.footer nav ul li::before{
    content: '';
    width: 3px;
    height: 3px;
    background-color: #C4C4C4;
    border-radius: 50%;
    position: absolute;
    left: -16px;
    top: 9px;
}
.footer nav ul li a{
    font-family: 'Montserrat SemiBold';
}
.footer nav ul li a:hover{
    color: #FF6A72 !important;
}

/* --- END FOOTER --- */

/* --- RESPONSIVE --- */

@media (max-width: 767px) {

    /* --- FOOTER --- */

    .footer .container > div{
        flex-direction: column !important;
    }
    .footer .copy{
        margin-bottom: 15px !important;
    }

    /* NAV */

    .footer nav{
        margin-left: 0;
    }
    .footer nav ul li:first-of-type::before{
        display: none;
    }

    /* --- END FOOTER --- */

}
@media (max-width: 460px) {

    /* NAV */

    .footer nav ul{
        flex-direction: column !important;
    }
    .footer nav ul li {
        margin: 5px 0px;
        text-align: center;
    }
    .footer nav ul li::before{
        display: none;
    }

    /* --- END FOOTER --- */

}

/* --- END RESPONSIVE --- */

/* --- RESPONSIVE --- */

@media (max-width: 1100px) {

    /* --- QR CODE --- */

    .qr-code .content-url .url{
        width: 57%;
    }
    .qr-code .content-url .content-button{
        width: 37%;
    }

    /* --- END QR CODE --- */
}

@media (max-width: 1024px) {

    /* --- QR CODE --- */

    .qr-code .content-url .url{
        width: 55%;
    }
    .qr-code .content-url .content-button{
        width: 40%;
    }

    /* --- END QR CODE --- */
}

@media (max-width: 982px) {

    /* --- QR CODE --- */

    .qr-code .content-url{
        flex-direction: column;
    }
    .qr-code .content-url .url {
        margin: 0 0 10px 0;
    }
    .qr-code .content-url .url p {
        max-width: 100%;
    }
    .qr-code .content-url .url,
    .qr-code .content-url .content-button{
        width: 100%;
        text-align: center;
    }

    /* --- END QR CODE --- */

}

@media (max-width: 600px) {

    /* --- QR CODE --- */

    .qr-code{
        padding: 20px;
    }

    /* --- END QR CODE --- */

}

/* --- END RESPONSIVE --- */


	/* FORM VALIDAITON PASS */

	form .validation-pass{
		padding: 15px 5px 15px 2px;
	}
	form .validation-pass ul{
		padding: 0;
		column-count: 2;
		column-gap: 0;
		margin-bottom: 0;
	}
	form .validation-pass ul li{
		margin: 0 0 10px;
	}
	form .validation-pass ul li,
	form .validation-pass ul li span{
		font-family: 'Montserrat Regular';
		font-size: 12px;
		color: #818181;
	}
	form .validation-pass ul li .icon-validation-pass {
		display: block;
		width: 12px;
		height: 12px;
		float: left;
		margin: 3px 15px 0 0;
	}
	form .validation-pass ul li.valid,
	form .validation-pass ul li.valid span{
		color: #609A3E;
	}
	form .validation-pass ul li.valid .icon-validation-pass{
		background: url(${IconCheck}) no-repeat center;
	}
	form .validation-pass ul li.invalid,
	form .validation-pass ul li.invalid span{
		color: #FF431C;
	}
	form .validation-pass ul li.invalid .icon-validation-pass{
		background: url(${IconDelete}) no-repeat center;
	}
	form .invalid-feedback{
		display: block !important;
		font-family: 'Montserrat Regular';
		font-size: 12px;
	}
	form .button{
		width: 100%;
	}
	.form.full figure{
		border: 1px solid #ECECEC;
		padding: 30px;
		border-radius: 30px;
		width: auto;
		float: left;
	}
	.form.full figure img{
		max-width: 200px;
	}
	.form.full .qrcode-generated {
		flex-direction: row;
		display: flex;
	}
	.form.full .qrcode-generated .download-qrcode {
		margin: 0 0 0 20px;
	}
	.form.full .qrcode-generated .download-qrcode a{
		margin-bottom: 10px;
	}
	.form.full .qrcode-generated .download-qrcode a:last-of-type{
		margin-bottom: 0px;
	}

	/* MODAL */

	.modal-yapps .btn-close{
		margin: 0 0 0 auto;
		font-size: 13px;
	}
	.modal-yapps .btn-close:focus{
		outline: none;
		box-shadow: none;
	}
	.modal-yapps .modal-content{
		border: 0;
		border-radius: 20px;
	}
	.modal-yapps .modal-header{
		padding-bottom: 0;
		margin-bottom: 0;
	}
	.modal-yapps .modal-header,
	.modal-yapps .modal-body,
	.modal-yapps .modal-footer{
		border: 0;
	}
	.modal-yapps .modal-body h2{
		color: #FF6A72;
		font-family: 'Montserrat Extrabold';
		font-style: normal;
		font-size: 20px;
		text-align: center;
	}
	.modal-yapps .modal-footer{
		justify-content: center;
		padding: 10px 0 40px;
	}

	/* Botoes social Component */
	.social .firebaseui-container {
		text-align: center;
	}

	.social .firebaseui-idp-list {
		display: inline-flex !important;
	}

	.social .firebaseui-idp-google,
	.social .firebaseui-idp-facebook,
	.social .firebaseui-idp-github{
		width: 57px;
		height: 60px;
		box-shadow: none !important;
	}

	.social .firebaseui-idp-google{
		background: #FFFFFF url(${IconGoogle}) no-repeat center !important;
	}

	.social .firebaseui-idp-facebook{
		background: #FFFFFF url(${IconFacebook}) no-repeat center !important;
	}

	.social .firebaseui-idp-github{
		background: #FFFFFF url(${IconGithub}) no-repeat center !important;
	}

	.social .firebaseui-idp-google .firebaseui-idp-text-long,
	.social .firebaseui-idp-google .firebaseui-idp-text-short,
	.social .firebaseui-idp-google .firebaseui-idp-icon-wrapper,

	.social .firebaseui-idp-facebook .firebaseui-idp-text-long,
	.social .firebaseui-idp-facebook .firebaseui-idp-text-short,
	.social .firebaseui-idp-facebook .firebaseui-idp-icon-wrapper,

	.social .firebaseui-idp-github .firebaseui-idp-text-long,
	.social .firebaseui-idp-github .firebaseui-idp-text-short,
	.social .firebaseui-idp-github .firebaseui-idp-icon-wrapper{
		display: none;
	}

	/* LANGUAGES */
	.languages{
		width: auto;
		height: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 0 0 0 17px;
		padding: 0 0 0 15px;
		border-left: 1px solid #F1F1F1;
	}
	.languages li{
		margin: 0 0 0 10px;
	}
	.languages li a{
		display: inline-flex;
		width: 28px;
		height: 28px;
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
	}
	.languages li a:hover{
		transform: scale(1.1);
	}
	.languages li a.en{
		background-image: url(${FlagUsaInactive});
	}
        .languages li a.pt{
                background-image: url(${FlagBrazilInactive});
        }
        .languages li a.es{
                background-image: url(${FlagSpainInactive});
        }
        .languages li a.it{
                background-image: url(${FlagItalyInactive});
        }
        .languages li a.tr{
                background-image: url(${FlagTurkeyInactive});
        }
        .languages li a.ar{
                background-image: url(${FlagSaudiInactive});
        }
        .languages li a.zh{
                background-image: url(${FlagChinaInactive});
        }
        .languages li.active a.en{
                background-image: url(${FlagUsaActive});
        }
        .languages li.active a.pt{
                background-image: url(${FlagBrazilActive});
        }
        .languages li.active a.es{
                background-image: url(${FlagSpainActive});
        }
        .languages li.active a.it{
                background-image: url(${FlagItalyActive});
        }
        .languages li.active a.tr{
                background-image: url(${FlagTurkeyActive});
        }
        .languages li.active a.ar{
                background-image: url(${FlagSaudiActive});
        }
        .languages li.active a.zh{
                background-image: url(${FlagChinaActive});
        }

	/* --- END LANGUAGES --- */

	/* RESPONSIVE */

	@media (max-width: 1400px) {
		.container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl{
			max-width: 1320px;
		}
	}
	@media (max-width: 1200px) {
		.container, .container-lg, .container-md, .container-sm, .container-xl{
			max-width: 1140px;
		}
	}
	@media (max-width: 1100px) {

		/* QRCODE - HOME */

		.generate-qrcode .container .card-generate .content {
			height: 100%;
			padding: 25px;
		}
		.generate-qrcode .container .card-generate .content .content-qrcode .buttons a {
			width: 49%;
			font-size: 12px;
			text-align: center;
			line-height: 13px;
		}

		/* LIST */

		.lines.card .line .time {
			align-items: flex-start !important;
			padding-left: 2px;
		}
		.lines.card .line .time span {
			font-size: 12px;
			margin-bottom: 0;
			margin-top: 5px;
		}
	}
	@media (max-width: 992px) {

		.container, .container-lg, .container-md, .container-sm{
			max-width: 960px;
		}
		main{
			padding-top: 100px;
		}

		/* NAVBAR */

		.navbar-toggler{
			border-radius: 0;
			transition: none;
			padding: 0;
			margin-top: -3px;
		}
		button:focus:not(:focus-visible),
		.navbar-toggler:focus{
			box-shadow: none;
			outline: none;
		}
		.navbar-toggler-icon {
			background: url(${IconMenu}) no-repeat center;
			width: 24px;
			height: 22px;
			background-size: contain;
		}
		.navbar-collapse form {
			padding: 15px 5px 30px;
			justify-content: center;
		}
		header .navbar-nav {
			padding: 20px 5px;
			text-align: center;
		}
		header nav.navbar .nav-item {
			margin: 0px;
			border-bottom: 1px solid #efefef;
			padding: 15px 0;
		}
		header nav.navbar .nav-item a{
			font-family: 'Montserrat Semibold';
		}
		header nav.navbar .nav-item.featured a{
			background: transparent;
			border: 0;
			color: #44393E;
			padding: .5rem 0;
			box-shadow: none;
		}
		header nav.navbar .nav-item.featured a:hover{
			box-shadow: none;
			padding: 0.5rem 0;
			color: #FF6A72;
		}

		/* BANNER HOME */

		.banner-home h2 {
			margin-bottom: 20px;
			font-size: 36px;
			line-height: 36px;
		}

		/* TABLE */
		.table .table-line p {
			margin-bottom: 0;
			font-size: 12px;
			line-height: 16px;
		}

		/* HOME LOGGED */

		.features-buttons .button-feature {
			margin-bottom: 30px;
		}
		.features-buttons .button-feature:last-of-type{
			margin-bottom: 0;
		}
	}
	@media (max-width: 767px) {

		.container, .container-md, .container-sm {
			max-width: 850px;
		}

		/* TITLES */

		h1.title, .title {
			font-size: 26px;
			line-height: 30px;
		}

		/* QRCODE HOME */

		.generate-qrcode {
			margin: 30px auto 20px;
		}
		.generate-qrcode .container .card-generate {
			height: auto;
			margin-bottom: 40px;
		}

		/* BANNER HOME */

		.banner-home {
			min-height: initial;
			margin-bottom: 80px;
		}
		.banner-home .row > div {
			text-align: center;
		}
		.banner-home .button {
			margin: auto;
		}
		.banner-home h2 {
			font-size: 26px;
			line-height: 26px;
		}

		/* SECTION TEXT & IMAGE */

		.section-image-text {
			margin-bottom: 0 !important;
			margin-top: 20px;
		}
		.section-image-text .text {
			max-width: 100%;
			margin: 40px 0 50px;
			text-align: center;
		}
		.section-image-text .image{
			max-width: 350px;
		}
		.section-image-text .button {
			margin: 20px auto 0px;
			max-width: 450px;
		}

		/* CONTENT */

		.content-page .title{
			margin: 40px auto;
		}
		.content-page .title h2 {
			font-size: 26px;
			line-height: 30px;
		}
		.content-page .text .featured{
			text-align: center;
			margin-bottom: 20px;
		}
		.content-page .text .featured:last-child{
			margin-bottom: 0;
		}
		.content-page .text .featured .icon{
			margin: 0 auto 15px;
		}

		/* CALL TO ACTION SIGN UP & LOG IN */

		.call-to-action{
			width: 100%;
			height: auto !important;
			min-height: 100px !important;
			padding: 60px 20px;
		}

		/* QR CODE */
		.qrcode .divisor div {
			margin-bottom: 0;
			flex-direction: column !important;
		}
		.qrcode .divisor .button {
			width: 100%;
			margin: 0 0 20px 0 !important;
		}

		/* INTERNAL */

		.logged.left .title-pages {
			margin: 20px 0 30px;
		}
		.logged .content-page .form .divisor .button {
			width: 100%;
			margin: 0 0 20px 0 !important;
		}
		.logged .content-page .form .divisor > div {
			flex-direction: column !important;
		}

		/* TABLE */

		.table {
			border-radius: 0;
			border: 0;
		}
		.table .title-table{
		display: none;
		}
		.table .table-line {
			padding: 20px;
			border: 1px solid #DEDEDE;
			border-radius: 20px;
			margin-bottom: 20px;
		}
		.table .table-line div a div{
			padding: 10px 0;
		}
		.table .table-line div span{
			display: block;
			font-size: 11px;
			color: #FF6A72;
			font-weight: 700;
		}
		.table .table-line .img {
			text-align: left;
		}

		/* LIST */

		.lines .line {
			padding: 15px;
		}
		.lines .line .img {
			width: 36px;
			height: 36px;
			margin-bottom: 10px;
		}
		.lines .line .img img {
			width: auto;
		}
		.lines .line .name{
			margin-bottom: 10px;
		}
		.lines .line .name span {
			margin-bottom: 0;
		}
		.lines .line .time {
			align-items: flex-start !important;
			padding-left: 2px;
			margin-left: initial !important;
		}
		.lines .line .time span {
			font-size: 12px;
			margin-bottom: 0;
		}
		.lines.card .line .time span {
			margin-top: 5px;
		}
		.lines .line .actions {
			margin-left: initial !important;
		}
		.lines .line .actions a {
			margin-left: 15px;
		}
		.lines .line .actions a{
			width: 22px;
			height: 22px;
		}
		.lines .line .actions a img{
			width: 22px;
		}

		/* PRICING */

		.section-plans {
			margin: 50px auto;
		}
		.section-faq {
			padding: 80px 20px;
		}
		.section-plans .plan {
			width: 100%;
			max-width: 500px;
			margin: 20px auto;
		}
		.section-plans .plan .price span,
		.section-plans .plan .price strong {
			font-size: 56px;
		}

		/* PLAN */

		.lines.plan .line .row div,
		.current-plan .line .row div{
			margin-bottom: 10px;
		}
		.current-plan .line .actions{
			justify-content: flex-start !important;
			margin-left: initial !important;
		}

		/* CARDS */

		.cards .card header {
			margin-bottom: 30px;
			flex-direction: column;
			align-items: flex-start !important;
		}
		.cards .card header > div {
			margin-bottom: 10px;
		}
		.cards .card header > div:last-of-type{
			margin-bottom: 0;
		}
		.cards .card header > div.name {
			margin-left: 0;
			width: 100%;
		}
		.cards .card .name span{
			margin-left: 0;
		}
		.cards .card header > div.time {
			float: left !important;
			margin-left: initial !important;
		}
		.cards .card .content {
			width: 100%;
			float: left;
			padding-left: 0;
		}
		.cards .divisor a{
			width: 100%;
			margin: 0 0 20px 0;
		}
		.cards .divisor > div{
			padding: 0 !important;
			flex-direction: column !important;
		}
		.cards .divisor a:last-of-type{
			margin-bottom: 0;
		}

		/* CHECKOUT */

		.checkout .checkout-buttons .buttons {
			width: 100%;
			flex-direction: column !important;
		}
		.checkout .checkout-buttons .buttons .btn-aba {
			width: 100%;
			margin-bottom: 20px;
		}
		.checkout .checkout-buttons .buttons .btn-aba:last-of-type{
			margin-bottom: 0;
		}
		.checkout .checkout-buttons .buttons .btn-aba a{
			justify-content: center;
		}

		/* PAGINATIONS */

		.container-pagination {
			flex-direction: column;
		}

		/* FORM */

		.logged .content-page .form.full .space{
			display: none;
		}

		/* FLAGSHIP */

		.content-flagship .img-coming-soon{
			margin: 30px auto;
			max-width: 550px;
		}
		.content-flagship .title{
			font-size: 36px;
			line-height: 36px;
			text-align: center;
			margin-bottom: 15px;
		}
		.content-flagship .text{
			text-align: center;
		}

	}
	@media (max-width: 600px) {

		/* BREADCRUMB */

		.breadcrumb li {
			position: relative;
			width: 100%;
		}
		.breadcrumb-item+.breadcrumb-item::before{
			display: none;
		}
		.breadcrumb-item+.breadcrumb-item{
			padding-left: 0;
		}

		/* CARDS */

		.cards .card {
			padding: 15px;
			border-radius: 30px;
		}
		.form.full figure {
			text-align: center;
		}
		.form.full .qrcode-generated {
			flex-direction: column;
		}
		.form.full .qrcode-generated .download-qrcode {
			margin: 0;
		}

		.content-flagship .img-coming-soon {
			margin-bottom: 35px;
		}

		/* CHECKOUT */

		.checkout .content {
			padding: 25px;
		}
		.checkout .checkout-buttons .buttons .btn-aba a span {
			font-size: 16px;
			line-height: 18px;
		}
		.checkout .checkout-buttons .buttons .btn-aba a p {
			font-size: 14px;
		}
		.checkout .content .tab-content .divisor span {
			font-size: 14px;
		}
		.checkout .content .price > div{
			flex-direction: column !important;
		}
		.checkout .content .price p {
			color: #44393E;
			margin-bottom: 10px;
			width: 100%;
		}

	}
	@media (max-width: 470px) {


		.section-image-text h1.title,
		.section-image-text h2.title,
		h2.subtitle,
		.title-pages h1 {
			font-size: 26px;
			line-height: 30px;
		}

		/* QRCODE - HOME */

		.generate-qrcode .container .card-generate .content .title h2{
			text-align: center;
		}
		.generate-qrcode .container .card-generate .content-qrcode .buttons {
			flex-direction: column;
			align-items: center;
		}
		.generate-qrcode .container .card-generate .content .content-qrcode .buttons a {
			width: 70%;
			margin: 8px;
		}
		.generate-qrcode .container .card-generate .content .content-qrcode p {
			text-align: center;
		}

		/* FORM */

		form .validation-pass ul {
			padding: 0;
			column-count: 1;
			column-gap: 0;
			margin-bottom: 0;
		}

		/* QRCODE */

		.qrcode div p {
			font-size: 16px;
		}
		.qrcode figure img {
			max-width: 100%;
		}
		.qrcode .download-qrcode a {
			width: 100%;
			margin-right: 0;
			margin-bottom: 15px;
		}
		.qrcode .download-qrcode a:last-of-type{
			margin-bottom: 0;
		}

		/* BUTTON */

		.button {
			font-size: 13px;
			padding: 0px 25px;
		}

		/* FLAGSHIP */

		.content-flagship .logo img {
			width: 200px;
		}
		.content-flagship .img-coming-soon {
			margin-top: 0;
		}
		.content-flagship .title {
			font-size: 28px;
			line-height: 32px;
			text-align: center;
			margin-bottom: 15px;
		}
	}
	@media (max-width: 360px){
	}

	/* PHONE INPUT */
	.yapps-phone-input{
		display: flex;
		align-items: center;
		width: 100%;
		height: 40px;
		border-bottom: 1px solid #EDEDED;
		gap: 8px;
	}
	.yapps-phone-input.error-input{
		border-bottom-color: #FF6A72;
	}
	.yapps-phone-input .PhoneInputCountry{
		display: flex;
		align-items: center;
		gap: 4px;
	}
	.yapps-phone-input .PhoneInputCountryIcon{
		width: 24px;
		height: 18px;
	}
	.yapps-phone-input .PhoneInputCountryIcon--border{
		box-shadow: none;
		background: transparent;
	}
	.yapps-phone-input .PhoneInputInput{
		flex: 1;
		height: 100%;
		border: 0 !important;
		border-bottom: 0 !important;
		background: transparent !important;
		padding: 0 !important;
		font-family: 'Montserrat ExtraLight';
		color: #44393E;
		outline: none;
	}
	.yapps-phone-input .PhoneInputInput::placeholder{
		color: #ADADAD;
	}
`;
